export const BOOK = "book"
export const PACKAGE = "package"
